import React from 'react';

const captions = [
  '100% free roadside assistance',
  'Real people here to help 24/7',
  'Get it delivered',
  'More reviews. More 5-star ratings',
];

const ValueProps = () => (
  <ul className="flex flex-col justify-center md:text-sm md:flex-row">
    {captions.map((caption, index) => {
      return (
        <li key={index} className="flex mr-4 last:mr-0">
          <span className="mr-2 text-gray-800">✓</span>
          <span>{caption}</span>
        </li>
      );
    })}
  </ul>
);

export default ValueProps;
